module.exports = __webpack_public_path__ + "334be4f4b98a948a0ce4dcdad0774aa5.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/dan-abramov.jpg
// module id = 437
// module chunks = 0